// Zentrales Fahrzeug-Bild-Mapping (Single Source of Truth)
// Genutzt von FahrzeugePage, DashboardPage und MagnetboardView.

import { useEffect, useState } from 'react';
import { dienstApi } from './api';

const DEFAULTS = {
  'LHF': '/images/fahrzeuge/lhf.png',
  'HLF': '/images/fahrzeuge/lhf.png',
  'DLK': '/images/fahrzeuge/dlk.png',
  'RTW': '/images/fahrzeuge/rtw.png',
  'NEF': '/images/fahrzeuge/nef.png',
  'ELW': '/images/fahrzeuge/elw.png',
  'TLF': '/images/fahrzeuge/tlf.png',
  'GW':  '/images/fahrzeuge/gw.png',
  'RW':  '/images/fahrzeuge/tlf.png',
  'KTW': '/images/fahrzeuge/rtw.png',
  'MZB': '/images/fahrzeuge/mzb.png',
};

// Modul-globaler State + Subscriber-Pattern für reaktive Updates
let customMap = {};
const subscribers = new Set();
let loadPromise = null;

function notify() {
  subscribers.forEach(fn => { try { fn(customMap); } catch (e) { /* ignore */ } });
}

function resolveByCode(code) {
  const k = String(code || 'LHF').toUpperCase();
  if (k === 'MZB' || k === 'RTB') {
    return customMap.MZB || customMap.RTB || DEFAULTS.MZB;
  }
  return customMap[k] || DEFAULTS[k] || DEFAULTS.LHF;
}

export function getDefaultFahrzeugBild(typCode) {
  const code = String(typCode || 'LHF').toUpperCase();
  return DEFAULTS[code === 'RTB' ? 'MZB' : code] || DEFAULTS.LHF;
}

// Legacy-API: Objekt-Lookup via Proxy → liefert immer aktuellen Stand
export const FAHRZEUG_BILDER = new Proxy({}, {
  get: (_t, key) => resolveByCode(key),
});

/** Lädt Custom-Bilder vom Backend. Idempotent. `force=true` umgeht den Cache. */
export async function loadCustomFahrzeugBilder(force = false) {
  if (loadPromise && !force) return loadPromise;
  loadPromise = dienstApi.getFahrzeugtypenBilder()
    .then(res => {
      // Cache-Buster Query-Param damit Browser SVG nach Upload neu lädt
      const ts = Date.now();
      const map = res.data || {};
      customMap = Object.fromEntries(
        Object.entries(map).map(([k, v]) => [k, v ? `${v}?v=${ts}` : v])
      );
      notify();
      return customMap;
    })
    .catch(() => customMap);
  return loadPromise;
}

/** React-Hook: lädt Custom-Bilder beim Mount und triggert Re-Render bei Änderungen. */
export function useFahrzeugBilder() {
  const [, setVersion] = useState(0);
  useEffect(() => {
    loadCustomFahrzeugBilder();
    const sub = () => setVersion(v => v + 1);
    subscribers.add(sub);
    return () => { subscribers.delete(sub); };
  }, []);
  return { get: resolveByCode };
}

export function getFahrzeugBild(fahrzeug) {
  const code = fahrzeug?.fahrzeugtyp_code || fahrzeug?.typ || '';
  const match = code.match(/^([A-Za-z]+)/);
  return resolveByCode(match ? match[1] : 'LHF');
}

export function getFahrzeugBildByTypCode(typCode) {
  return resolveByCode(typCode);
}
